import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Philosophy from "./sections/Philosophy";
import Foundations from "./sections/Foundations";
import Copilot from "./sections/Copilot";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <Philosophy />
      <Foundations />
      <Copilot />
      <Consultation />
      <Footer />
    </div>;
}